import { z } from "zod";
export const serviceSubtypes = [
    "Bulk Packages",
    "Pallets",
    "Parcel Batches",
    "Other",
];
export const middlemileSchema = z.object({
    serviceSubtype: z.enum(serviceSubtypes, { message: "Select type" }),
    description: z.string().min(1, "Required").max(500, "Max 500 characters"),
    weightKg: z.number().positive("Weight must be positive"),
    palletCount: z.number().int().min(0).optional(),
    isOvernight: z.boolean().optional(),
    photos: z.array(z.string()).max(3, "Max 3 photos").optional(),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=schema.js.map